export const CATALOG_LIMIT_LABELS = {
  loading: "Plan limits are still loading. Please try again.",
  productLimit: (limit) => `Your plan allows up to ${limit} products per store.`,
  serviceLimit: (limit) => `Your plan allows up to ${limit} services per store.`,
  importedProducts: (count) =>
    `Only ${count} additional products fit within your plan limit.`,
  importedServices: (count) =>
    `Only ${count} additional services fit within your plan limit.`,
  productButtonTitle: (limit) => `Plan limit: ${limit} products per store`,
  serviceButtonTitle: (limit) => `Plan limit: ${limit} services per store`,
  privateStoreTitle: "Private Biz requires the Turbo plan",
  privateStoreError:
    "Private Biz requires the Turbo plan. Upgrade or set visibility to Public.",
};
